<template>
  <div>
    <div class="tabs" role="tablist" aria-label="제품 분류">
      <button type="button" class="tab" :class="{ on: current === 'all' }" role="tab" :aria-selected="current === 'all'" @click="select('all')">전체 <span class="cnt">{{ products.length }}</span></button>
      <button v-for="c in categories" :key="c.key" type="button" class="tab" :class="{ on: current === c.key }" role="tab" :aria-selected="current === c.key" @click="select(c.key)">{{ c.label }} <span class="cnt">{{ countOf(c.key) }}</span></button>
    </div>
    <transition-group name="grid" tag="div" class="grid">
      <article v-for="p in visible" :key="p.name" class="item card">
        <div class="thumb"><img :src="p.img" :alt="p.name" loading="lazy" /></div>
        <div class="body">
          <div class="cat">{{ labelOf(p.cat) }}</div>
          <h3 class="name">{{ p.name }}</h3>
          <p class="desc">{{ p.desc }}</p>
          <ul class="specs"><li v-for="sp in p.specs" :key="sp">{{ sp }}</li></ul>
        </div>
      </article>
    </transition-group>
    <div v-if="hiddenCount > 0" class="more-wrap">
      <button type="button" class="btn btn-ghost" @click="expanded = true">제품 {{ hiddenCount }}개 더 보기</button>
    </div>
  </div>
</template>

<script>
import { products, productCategories } from '@/data/company';

export default {
  name: 'ProductsSection',
  data() { return { products, categories: productCategories, current: 'all', expanded: false, initial: 6 }; },
  computed: {
    shown() { return this.current === 'all' ? this.products : this.products.filter((p) => p.cat === this.current); },
    visible() { return this.expanded ? this.shown : this.shown.slice(0, this.initial); },
    hiddenCount() { return this.shown.length - this.visible.length; },
  },
  methods: {
    select(key) { this.current = key; this.expanded = false; },
    countOf(key) { return this.products.filter((p) => p.cat === key).length; },
    labelOf(key) { const c = this.categories.find((x) => x.key === key); return c ? c.label : ''; },
  },
};
</script>

<style scoped>
.tabs { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 24px; }
.tab { border: 1px solid var(--line); background: var(--card); color: var(--ink-2); border-radius: 999px; padding: 10px 16px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all .15s ease; }
.tab:hover { border-color: var(--ink); color: var(--ink); }
.tab.on { background: var(--navy); border-color: var(--navy); color: #ffffff; }
.cnt { opacity: 0.6; font-weight: 500; margin-left: 2px; }
.grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
.item { overflow: hidden; display: flex; flex-direction: column; }
.thumb { background: #fdf8f1; height: 210px; display: flex; align-items: center; justify-content: center; padding: 16px; border-bottom: 1px solid var(--line); }
.thumb img { max-height: 100%; max-width: 100%; object-fit: contain; }
.body { padding: 22px 24px 24px 24px; display: flex; flex-direction: column; gap: 8px; }
.cat { font-size: 11px; font-weight: 700; color: var(--orange); letter-spacing: 0.12em; }
.name { font-size: 18px; font-weight: 700; line-height: 1.3; }
.desc { font-size: 14px; color: var(--ink); font-weight: 500; }
.specs { margin: 6px 0 0 0; padding-left: 16px; font-size: 13px; line-height: 1.7; color: var(--ink-2); }
.more-wrap { display: flex; justify-content: center; margin-top: 20px; }
.grid-enter-active, .grid-leave-active { transition: opacity .2s ease; }
.grid-enter-from, .grid-leave-to { opacity: 0; }
.grid-leave-active { position: absolute; visibility: hidden; }
@media (max-width: 900px) { .grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 600px) { .grid { grid-template-columns: minmax(0, 1fr); } .thumb { height: 180px; } }
</style>
